<template>
  <div>

    <DataTable ref="smsDataTable" :url="api.ACTIONS.SMS_CODES" :titles="titles"
      :fields-hidden-main="['id', 'updated_at']" :title="$t('communication.smsCodes.title')" :enableEdit="false" :enableAdd="false"
      :enableDelete="false"  :formatter="formatter" />
  </div>
</template>

<style>
.hbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";

export default {
  name: "SMS Codes",
  title() {
    return this.$t("communication.smsCodes.title");
  },
  components: { DataTable },
  data() {
    return {};
  },

  computed: {
    rules() {
      return {
        name: [required],
      };
    },
    formatter() {
      return {
        created_at: (value) => this.moment(value).format('DD-MM-YYYY - HH:mm')
      }
    },
    titles() {
      return {
        phone_number: this.$t("communication.smsCodes.phone"),
        code: this.$t("communication.smsCodes.code"),
        created_at: this.$t("communication.smsCodes.creationTime"),
        end_time: this.$t("communication.smsCodes.endTime"),
      };
    },
    actionsExtraMain() {
      return {
      };
    },
  },
};
</script>
